export const selectStatsData = state => state.stats
